const getSleep = (ms: number): Promise<number> =>
  new Promise(resolve => {
    setTimeout(resolve, ms)
  })

export default getSleep
